<script>
  import miniToastr from 'mini-toastr'

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }

  miniToastr.init({
    types: toastTypes,
    timeout: 3000,
    style: {}
  })

  miniToastr.setIcon('error'  , 'i', {'class': 'icon-error fa fa-warning'})
  miniToastr.setIcon('info'   , 'i', {'class': 'icon-info fa fa-info-circle'})
  miniToastr.setIcon('success', 'i', {'class': 'icon-success fa fa-check-circle-o'})
  miniToastr.setIcon('warn'   , 'i', {'class': 'icon-warn fa fa-warning'})

  /**
   * Mostra a mensagem com o toaster, dependendo do tipo de
   * status.
   *
   */
  const toast = function ({title, message, status, timeout, cb}) {
    if (status === 'success')  {
      return miniToastr.success(message, title, timeout, cb)
    }
    if (status === 'error') {
      return miniToastr.error(message, title, timeout, cb)
    }
    if (status === 'info') {
      return miniToastr.info(message, title, timeout, cb)
    }
    if (status === 'warn') {
      return miniToastr.warn(message, title, timeout, cb)
    }
  }

  export default {
    toast
  }
</script>

<style>
  .icon-success {
    color: #7AC13E;
  }
  .icon-warn {
    color: #F5AA1E;
  }
  .icon-info {
    color: #4196E1;
  }
  .icon-error {
    color: #D5122B;
  }
  #mini-toastr {
    position: fixed;
    z-index: 99999;
    right: 12px;
    top: 12px;
  }
  .mini-toastr__notification {
    cursor: pointer;
    padding: 12px 18px;
    margin: 0 0 6px 0;
    opacity: 0.8;
    border-radius: 3px;
    box-shadow: #3c3b3b 0 0 12px;
    width: 300px;
    color: #000;
    background-color: #FFFFFF;
  }
  .mini-toastr-notification__message {
    display: inline-block;
    vertical-align: middle;
    width: 240px;
    padding: 0 12px;
  }
  .mini-toastr__notification:hover {
    opacity: 1;
    box-shadow: #000 0 0 12px;
  }
  .-error {
    color: #000;
    background-color: #FFFFFF;
  }
</style>
